module.exports = require('./dist/src/components/button-next');



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/button-next.js
// module id = 1347
// module chunks = 0